/**
 * WD Email Newsletter with Background — consent validation + legal links in modal.
 */
(function () {
  function init(root) {
    if (!root || root.dataset.wdEnbInit === '1') return;
    root.dataset.wdEnbInit = '1';

    const form = root.querySelector('.wd-enb__form-block form') || root.querySelector('.wd-sp-newsletter-form form');
    const checkbox = root.querySelector('.wd-enb__consent-check input[type="checkbox"]');
    const hiddenConsent = root.querySelector('.wd-enb__consent-hidden');
    const consentError = root.querySelector('.wd-enb__consent-error');
    const legalModal = root.querySelector('.wd-enb__legal-modal');
    const legalIframe = root.querySelector('.wd-enb__legal-iframe');
    const legalTitle = root.querySelector('.wd-enb__legal-title');

    function syncWdEnbConsentHidden() {
      if (hiddenConsent && checkbox) hiddenConsent.disabled = !!checkbox.checked;
    }

    if (checkbox) {
      syncWdEnbConsentHidden();
      checkbox.addEventListener('change', function () {
        syncWdEnbConsentHidden();
        if (checkbox.checked) {
          if (consentError) consentError.hidden = true;
          checkbox.removeAttribute('aria-invalid');
        }
      });
    }

    if (form && checkbox) {
      form.addEventListener(
        'submit',
        function (e) {
          if (!checkbox.checked) {
            e.preventDefault();
            e.stopPropagation();
            if (consentError) {
              consentError.hidden = false;
              consentError.setAttribute('role', 'alert');
            }
            checkbox.setAttribute('aria-invalid', 'true');
            checkbox.focus();
          }
        },
        true
      );
    }

    const consentRte = root.querySelector('.wd-enb__consent');
    if (consentRte && checkbox) {
      consentRte.addEventListener('click', function (e) {
        const a = e.target.closest('a[href]');
        if (a) {
          if (!legalModal || !legalIframe) return;
          const href = a.getAttribute('href') || '';
          if (!href || href.startsWith('#') || href.startsWith('mailto:') || href.startsWith('tel:')) return;
          e.preventDefault();
          legalIframe.removeAttribute('src');
          legalIframe.src = href;
          if (legalTitle) legalTitle.textContent = a.textContent.trim() || '';
          legalIframe.setAttribute('title', a.textContent.trim() || 'Legal');
          if (typeof legalModal.show === 'function') {
            legalModal.show();
          } else {
            legalModal.removeAttribute('hidden');
          }
          return;
        }
        checkbox.click();
      });
    }

    if (legalModal) {
      legalModal.addEventListener('modal:handleAfterHide', function () {
        if (legalIframe) legalIframe.removeAttribute('src');
      });
    }
  }

  document.querySelectorAll('[data-wd-enb-root], [data-wd-sp-consent-root]').forEach(init);

  document.addEventListener('shopify:section:load', function (e) {
    const sec =
      (e.target && e.target.querySelector && e.target.querySelector('[data-wd-enb-root]')) ||
      (e.target && e.target.querySelector && e.target.querySelector('[data-wd-sp-consent-root]'));
    if (sec) init(sec);
  });
})();
